<div class="loader-icon" [attr.data-animation]="animation()">
  <i [ngClass]="icon()" aria-hidden="true"></i>
</div>
@if (text()?.length > 0) {
  <div class="loader-text">
    <span class="text">{{ text() }}</span>
    <span class="dots"></span>
  </div>
}
